import ContentHeading from "@/components/content-heading";
import { useTranslation } from "react-i18next";
// Tailwind classes
import { wrapper, blogs } from "./styles";

const MhealthBlogs: React.FC<{
  component: React.ReactElement;
}> = ({ component }) => {
  const { t } = useTranslation();

  return (
    <section
      className={wrapper}
      title={t("index.latest-blogs.seo.title")}
      aria-label={t("index.latest-blogs.seo.aria-label")}
    >
      <div className={blogs}>{component}</div>
    </section>
  );
};

export default MhealthBlogs;
